import ValueYourTradeWidget from '../../../../../global/js/misc/value-your-trade-widget/valueYourTradeWidget';

export default () => {
    ValueYourTradeWidget.getInstance();
};
